import { render } from "./AssetManagerFile.vue?vue&type=template&id=5628872e"
import script from "./AssetManagerFile.vue?vue&type=script&lang=js"
export * from "./AssetManagerFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__